/*
  Hydrion cart drawer (replaces the UpCart app).
  The drawer is a <cart-notification id="HyCart"> element, so the theme's product-form.js / quick-add.js
  hand it every add-to-cart (getSectionsToRender + renderContents) exactly like Dawn's own cart notification.
  Content is server-rendered by sections/hy-cart-drawer.liquid (Section Rendering API), so currency,
  free-shipping thresholds and copy follow the visitor's market and language.
  Cart changes made by anything else on the page (apps, custom buttons, add-on sensor, subscription
  widget) are picked up by watching /cart/add|change|update|clear requests; adds open the drawer.
*/
(function () {
  if (!window.HY_OFFLOAD || customElements.get('cart-notification')) return;

  var SECTION = 'hy-cart-drawer';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var baseFetch = window.fetch.bind(window);
  var armedAt = Infinity;
  function arm() { armedAt = performance.now() + 500; }
  if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm);

  function json(r) { return r.json(); }
  function post(path, body) {
    body.sections = [SECTION];
    body.sections_url = window.location.pathname;
    return baseFetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(json);
  }
  function announce(cartData) {
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hy-cart', cartData: cartData });
      }
    } catch (e) {}
  }

  class HyCart extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.slide = 0;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-hyc-input]')) { e.preventDefault(); e.target.blur(); }
      });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && this.isOpen()) this.close(); });
      this.initCarousel();
    }

    /* --- Dawn cart-notification interface --- */
    getSectionsToRender() { return [{ id: SECTION }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsed) {
      if (parsed && parsed.sections && parsed.sections[SECTION]) this.renderHTML(parsed.sections[SECTION]);
      else this.refresh();
      this.open();
    }

    isOpen() { return this.classList.contains('is-open'); }
    open() {
      if (this.isOpen()) return;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hyc-lock');
      var close = this.querySelector('.hyc-close');
      if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 50);
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hyc-lock');
      if (this.activeElement && this.activeElement.focus) { try { this.activeElement.focus({ preventScroll: true }); } catch (e) {} }
    }

    renderHTML(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-hyc-body]');
      var current = this.querySelector('[data-hyc-body]');
      if (fresh && current) {
        current.replaceWith(fresh);
        this.initCarousel();
      }
    }
    refresh() {
      return baseFetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(json)
        .then((d) => this.renderHTML(d && d[SECTION]))
        .catch(function () {});
    }

    setLoading(on) { this.classList.toggle('is-loading', !!on); }
    change(line, qty) {
      this.setLoading(true);
      return post('cart/change.js', { line: line, quantity: Math.max(0, qty) })
        .then((d) => {
          if (d && d.sections && d.sections[SECTION]) this.renderHTML(d.sections[SECTION]);
          else return this.refresh();
          if (d && d.items) announce(d);
        })
        .catch(() => this.refresh())
        .finally(() => this.setLoading(false));
    }
    addVariant(id, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      this.setLoading(true);
      return post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
        .then((d) => {
          if (d && d.sections && d.sections[SECTION]) this.renderHTML(d.sections[SECTION]);
          else return this.refresh();
          announce(d);
        })
        .catch(() => this.refresh())
        .finally(() => { this.setLoading(false); if (btn) btn.removeAttribute('aria-busy'); });
    }

    onClick(e) {
      var t = e.target;
      if (t.closest('[data-hyc-close]')) { e.preventDefault(); this.close(); return; }
      var item = t.closest('[data-line]');
      var stepBtn = t.closest('[data-hyc-step]');
      if (stepBtn && item) {
        var input = item.querySelector('[data-hyc-input]');
        var next = (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-hyc-step'), 10);
        this.change(Number(item.getAttribute('data-line')), next);
        return;
      }
      var rm = t.closest('[data-hyc-qty]');
      if (rm && item) { this.change(Number(item.getAttribute('data-line')), 0); return; }
      var add = t.closest('[data-hyc-add]');
      if (add) { e.preventDefault(); this.addVariant(add.getAttribute('data-hyc-add'), add); return; }
      var nav = t.closest('[data-hyc-slide]');
      if (nav && !nav.disabled) { this.go(this.slide + parseInt(nav.getAttribute('data-hyc-slide'), 10)); }
    }
    onChange(e) {
      var input = e.target.closest('[data-hyc-input]');
      if (!input) return;
      var item = input.closest('[data-line]');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty)) qty = 1;
      this.change(Number(item.getAttribute('data-line')), qty);
    }

    initCarousel() {
      this.slide = 0;
      this.go(0);
    }
    go(i) {
      var c = this.querySelector('[data-hyc-carousel]');
      if (!c) return;
      var n = parseInt(c.getAttribute('data-count'), 10) || 1;
      this.slide = Math.max(0, Math.min(n - 1, i));
      var track = c.querySelector('[data-hyc-track]');
      if (track) track.style.transform = 'translateX(' + (-100 * this.slide) + '%)';
      var btns = c.querySelectorAll('[data-hyc-slide]');
      if (btns[0]) btns[0].disabled = this.slide === 0;
      if (btns[1]) btns[1].disabled = this.slide >= n - 1;
      var slides = c.querySelectorAll('.hyc-slide');
      for (var k = 0; k < slides.length; k++) {
        slides[k].setAttribute('aria-label', (k + 1) + ' / ' + n);
        slides[k].toggleAttribute('inert', k !== this.slide);
      }
    }
  }
  customElements.define('cart-notification', HyCart);

  /* --- cart changes made by anything else on the page --- */
  var pending = null, pendingOpen = false;
  function onExternal(isAdd) {
    var drawer = document.getElementById('HyCart');
    if (!drawer) return;
    if (isAdd && performance.now() > armedAt) pendingOpen = true;
    clearTimeout(pending);
    pending = setTimeout(function () {
      var openIt = pendingOpen;
      pendingOpen = false;
      drawer.refresh().then(function () { if (openIt) drawer.open(); });
    }, 120);
  }
  function urlOf(input) { return (typeof input === 'string' ? input : (input && input.url)) || ''; }

  window.fetch = function (input, init) {
    var p = baseFetch(input, init);
    try {
      var url = urlOf(input);
      if (CART_RE.test(url)) {
        p.then(function (r) { if (r && r.ok) onExternal(/\/cart\/add/.test(url)); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._hycUrl = String(url || ''); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (CART_RE.test(xhr._hycUrl || '')) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) onExternal(/\/cart\/add/.test(xhr._hycUrl));
      });
    }
    return xSend.apply(this, arguments);
  };

  /* --- header cart icon opens the drawer --- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var drawer = document.getElementById('HyCart');
    if (!drawer) return;
    e.preventDefault();
    drawer.setActiveElement(link);
    drawer.open();
    drawer.refresh();
  }, true);


  /* --- volume bundle selector (snippets/hy-volume-bundle.liquid) --- */
  function initBundle(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.hidden = false;
    var formId = root.getAttribute('data-form');
    var prices = {};
    try { prices = JSON.parse(root.querySelector('[data-hy-vb-prices]').textContent); } catch (e) {}
    var opts = Array.prototype.slice.call(root.querySelectorAll('.hy-vb__opt'));
    var qty = 1;
    function qtyInput() {
      var f = document.getElementById(formId);
      if (!f) return null;
      var i = f.querySelector('input[name="quantity"][data-hy-vb]');
      if (!i) {
        i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'quantity';
        i.setAttribute('data-hy-vb', '');
        f.appendChild(i);
      }
      return i;
    }
    function select(opt) {
      qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
      opts.forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.tabIndex = on ? 0 : -1;
        o.querySelector('input').checked = on;
      });
      var i = qtyInput();
      if (i) i.value = qty;
    }
    function setVariant(id) {
      var p = prices[String(id)];
      if (!p) return;
      root.querySelectorAll('[data-p]').forEach(function (el) { el.textContent = p[parseInt(el.getAttribute('data-p'), 10)]; });
    }
    opts.forEach(function (o, idx) {
      o.addEventListener('click', function () { select(o); });
      o.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(o); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = opts[(idx + 1) % opts.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = opts[(idx - 1 + opts.length) % opts.length];
        if (n) { e.preventDefault(); select(n); n.focus(); }
      });
    });
    var f = document.getElementById(formId);
    var idInput = f && f.querySelector('input[name="id"]');
    if (idInput) setVariant(idInput.value);
    select(opts[0]);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t.form && t.form.id === formId) { setVariant(t.value); var i = qtyInput(); if (i) i.value = qty; }
    });
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          if (ev && ev.data && ev.data.variant) setVariant(ev.data.variant.id);
          setTimeout(function () { var i = qtyInput(); if (i) i.value = qty; }, 0);
        });
      }
    } catch (e) {}
  }
  function scanBundles() { document.querySelectorAll('.hy-vb').forEach(initBundle); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanBundles); else scanBundles();
  var scanQueued = false;
  new MutationObserver(function () {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () { scanQueued = false; scanBundles(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* back/forward cache: the server-rendered cart may be stale */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { var d = document.getElementById('HyCart'); if (d) d.refresh(); }
  });
})();
